import type { FlightsTranslations } from "@/service/translate/flights/flightTranslations.types"

const flightsNlTranslations: FlightsTranslations = {
    "flightPage": {
        "title": "Flight",
        "step": "Step",
        "resultsFound": "Vol dénichées par nos experts"

    },
    "flightSortBy": {
        title: "Sorteren op",
        price_asc: "Laagste prijs eerst",
        price_desc: "Hoogste prijs eerst",
        fastest: "Snelste",
        long_stay: "Meer skitijd"
    },
    "flightBlock": {
        "title": "Flight Block Title",
        "direct": "Direct"
    },
    "flightFilters": {
        "outboundTrip": {
            "title": "outboundTrip",
            "duration": "Duration",

            "departure": {
                "location": "Vertrekluchthaven",
                "time": "Departure Time"
            },
            "arrival": {
                "location": "Arrival Location",
                "time": "Arrival Time"
            }
        },
        "inboundTrip": {
            "title": "inboundTrip",
            "duration": "Duration",
            "departure": {
                "location": "Departure Location",
                "time": "Departure Time"
            },
            "arrival": {
                "location": "Arrival Location",
                "time": "Arrival Time"
            }
        },
        "duration": "Flight duration",
        "airlines": "Plating Carrier"
    },
    "airportsNames": {
        "ABZ": "Aberdeen",
        "ACI": "Alderney",
        "BFS": "Belfast International",
        "BHD": "George Best Belfast City",
        "BHX": "Birmingham",
        "BOH": "Bournemouth",
        "BRS": "Bristol",
        "CWL": "Cardiff",
        "CEG": "Chester Hawarden",
        "LDY": "City of Derry",
        "CAX": "Carlisle Lake District",
        "DSA": "Doncaster Sheffield",
        "DND": "Dundee",
        "EMA": "East Midlands",
        "EDI": "Edinburgh",
        "EXT": "Exeter",
        "GCI": "Guernsey",
        "GLA": "Glasgow",
        "PIK": "Glasgow Prestwick",
        "HUY": "Humberside",
        "INV": "Inverness",
        "IOM": "Isle of Man",
        "JER": "Jersey",
        "LBA": "Leeds Bradford",
        "LPL": "Liverpool John Lennon",
        "LCY": "London City",
        "LGW": "London Gatwick",
        "LHR": "London Heathrow",
        "LTN": "London Luton",
        "SEN": "London Southend",
        "STN": "London Stansted",
        "MAN": "Manchester",
        "NCL": "Newcastle International",
        "NQY": "Newquay",
        "NWI": "Norwich",
        "SOU": "Southampton",
        "MME": "Teesside International",
        "LYS": "Lyon-Saint-Exupéry",
        "GNB": "Grenoble Alpes Isère",
        "GVA": "Genève-Cointrin",
        "CMF": "Chambéry-Savoie",
        "MFL": "Mount Full Stop Luchthaven",
        "TRN": "Turin-Caselle",
        "SNN": "Shannon",
        "ORK": "Cork",
        "NOC": "Ireland West Knock",
    },
    "airlinesNames": {
        "U2": "easyJet",
        "LS": "Jet2.com",
        "BA": "British Airways",
        "BY": "TUI Airways",
        "LX": "Swiss International Air Lines",
        "AF": "Air France",
        "V7": "Volotea",
        "LH": "Lufthansa",
        "KL": "KLM Royal Dutch Airlines",
        "IB": "Iberia",
        "W9": "Wizz Air",
        "EI": "Aer Lingus",
        "FR": "Ryanair",
        "WW": "WOW air",
    }
}

export default flightsNlTranslations;